import Newsletter_39Container from "./container/Newsletter_39Container";
export default Newsletter_39Container;
